import { FaHeart, FaUsers, FaSitemap } from "react-icons/fa";
import { FaHouse } from "react-icons/fa6";
interface DesktopSidebarNavItem {
  icon: React.ReactNode;
  label: string;
  navigateTo: string;
}

export interface DesktopSidebarItemState {
  action: DesktopSidebarNavItem;
  isHighlighted: boolean;
}

const home: DesktopSidebarNavItem = {
  icon: <FaHouse />,
  label: "Home",
  navigateTo: "/",
};

const myFundraisers: DesktopSidebarNavItem = {
  icon: <FaHeart />,
  label: "My Fundraisers",
  navigateTo: "/dashboard/user/",
};

// Define the use of the dashboard and then create a list of actions and whether
// or not they are highlighted. Only one should be highlighted for any given
// sidebar action set -> the button that links to the current page
export const GeneralUserDashboardSidebarActions: DesktopSidebarItemState[] = [
  { action: home, isHighlighted: false },
  { action: myFundraisers, isHighlighted: true },
];

const teamAdmin: DesktopSidebarNavItem = {
  icon: <FaUsers />,
  label: "My Team",
  navigateTo: "/dashboard/user/",
};

const coordinator: DesktopSidebarNavItem = {
  icon: <FaSitemap />,
  label: "Fundraiser Overview",
  navigateTo: "/dashboard/user/",
};

export const TeamAdminDashboardSidebarActions: DesktopSidebarItemState[] = [
  { action: home, isHighlighted: false },
  { action: myFundraisers, isHighlighted: false },
  { action: teamAdmin, isHighlighted: true },
];

export const CoordinatorDashboardSidebarActions: DesktopSidebarItemState[] = [
  { action: home, isHighlighted: false },
  { action: myFundraisers, isHighlighted: false },
  { action: coordinator, isHighlighted: true },
];
